// @ts-expect-error Ignore
import runnerPlayerApiTypes from "./commands.api.d.ts?raw";
// @ts-expect-error Ignore
import aiPageTypes from "./editor/aiPage.d.ts?raw";
// @ts-expect-error Ignore
import excelConverterApiTypes from "./editor/excel.converter.d.ts?raw";

import { externalTypes } from "./external-types/external-types";

export type SupportedNativeApis = "faker" | "z" | "page" | "runnerApi" | "ai" | "excelApi";

export const nativeApis = [
  {
    name: "external",
    value: externalTypes,
    isModule: true,
    variables: [
      { name: "faker", type: "fakerLib.Faker" },
      { name: "z", type: "typeof zod" },
      {
        name: "page",
        type: "puppeteer.Page & { waitForReady: (abortSignal: AbortSignal, initialDelayMs?: number) => Promise<void> }",
      },
    ],
  },
  {
    name: "runner",
    value: runnerPlayerApiTypes,
    isModule: false,
    namespace: "runner",
    variables: [{ name: "runnerApi", type: "runner.RunnerPlayerApi" }],
  },
  {
    name: "ai",
    value: aiPageTypes,
    isModule: false,
    namespace: "aiPage",
    variables: [{ name: "ai", type: "aiPage.AiPage" }],
  },
  {
    name: "excel",
    value: excelConverterApiTypes,
    isModule: false,
    namespace: "excel",
    variables: [{ name: "excelApi", type: "excel.Excel" }],
  },
];
